<template>
  <section>
    <h2 class="h2Title">선물 관리</h2>
    <article class="fieldMb">
      <form class="fieldWrap">
        <div class="fieldBx">
          <ul>
            <li class="formList">
              <dl>
                <dd>
                  <date-range-component v-on:event="getSearchDate" label="생성일"
                                        :value="param.searchDate"></date-range-component>
                </dd>
                <dd>
                  <div class="monthBx">
                    <button type="button" class="btn month" v-for="(month, idx) in monthLists"
                            :class="{ active: month === activeItem}"
                            @click="selectSearchDate(month.value, idx)" :key="idx">{{ month.text }}
                    </button>
                  </div>
                </dd>
              </dl>
              <dl>
                <dd>
                  <v-col sm="6">
                      <v-text-field  v-model="param.searchKeyword" v-on:keyup.enter="search" label="제목 / 내용 검색" dense solo clearable flat outlined />
                  </v-col>
                </dd>
              </dl>

            </li>
          </ul>
        </div>
      </form>
    </article>
    <article class="tableWrap">
      <div class="tableBtnBx">
        <p class="searchAll">
        </p>
        <div class="tableBtn">
          <ul>
            <li class="tableBtnList">
              <v-btn color="primary" class="vBtn vIconResize mgr" @click="$router.push({path: `/present/form`})">
                <v-icon class="mr-2">mdi mdi-playlist-plus</v-icon> 등록
              </v-btn>
            </li>
          </ul>
        </div>
      </div>
      <div class="tableBx">
        <v-data-table
            :headers="headers"
            :items="datasets"
            :server-items-length="totalItems"
            :options.sync="options"
            class="elevation-1"
            disable-sort
            @click:row="updateForm"
        >
          <template v-slot:item.idx="{item}">
            {{totalItems - (datasets.indexOf(item)) - (( (options.page ? options.page : 1) - 1) * options.itemsPerPage)}}
          </template>
          <template v-slot:item.createdAt="{ value }">
            {{ value | moment('YYYY.MM.DD HH:mm') }}
          </template>
          <template v-slot:item.requestDt="{ item }">
            {{ item.startDt ? $moment(item.startDt, 'YYYYMMDDHHmmss').format('YYYY.MM.DD') : '' }}
            {{ item.endDt ? ' ~ ' + $moment(item.endDt, 'YYYYMMDDHHmmss').format('YYYY.MM.DD') : '' }}

          </template>
          <template v-slot:item.state="{ value }">
            {{ stateList.find(p => p.value === value).text }}
          </template>
          <template v-slot:item.activated="{ value }">
            {{ value ? '사용' : '사용 안함' }}
          </template>
          <template v-slot:item.always="{ value, item }">
            {{ value ? '상시' : `${item.startDt} ${item.startTm} ~ ${item.endDt} ${item.endTm} ` }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn color="info" @click.prevent.stop="preview(item)" dark small style="margin-right: 2px">
              <v-icon
                  small
                  class="mr-2"
              >
                mdi-newspaper-variant-multiple
              </v-icon>
              미리보기
            </v-btn>

            <v-btn color="primary" @click.prevent.stop="updateForm(item)" dark small style="margin-right: 2px">
              <v-icon
                  small
                  class="mr-2"
              >
                mdi-pencil
              </v-icon>
              수정
            </v-btn>

            <v-btn color="orange" @click.prevent.stop="deletePresent(item)" dark small>
              <v-icon
                  small
                  class="mr-2"
              >
                mdi-delete
              </v-icon>
              삭제
            </v-btn>
          </template>
        </v-data-table>

      </div>
    </article>

  </section>
</template>
<script>

import presentApi from '@/api/PresentApi';
import 'codemirror/lib/codemirror.css';
import '@toast-ui/editor/dist/toastui-editor.css';
import DateRageComponent from "@/views/component/DateRageComponent";

export default {
  name: 'Present',
  components: {
    'date-range-component': DateRageComponent,
  },
  data: () => ({
        monthLists: [
          {value: 1, text: '1개월'}, {value: 3, text: '3개월'}, {value: 6, text: '6개월'},
          {value: 12, text: '1년'}, {value: 0, text: '전체'}],
        activeItem: null,
        searchField : 'present_name',
        searchValue : '',
        present:{},
        datasets: [],
        totalItems: 0,
        options:{},
        param: {
          searchDate:[],
          searchKeyword: null,
          page: 1
        },
        headers:[
          {
            text: '번호',
            value: 'idx',
            align: 'left',
          },
          {
            text: '기준일(기념일)',
            value: 'presentDate',
            align: 'center',
          },
          {
            text: '제목',
            value: 'title',
            align: 'left',
          },
          {
            text: '상태',
            value: 'state',
            align: 'center',
          },
          {
            text: '접수기간',
            value: 'requestDt',
            align: 'center',
          },
          {
            text: '생성일',
            value: 'createdAt',
            align: 'center',
          },
          {
            text: '사용여부',
            value: 'activated',
            align: 'center',
          },
          {
            text: 'Actions',
            value: 'actions',
            align: 'left',
          }
        ],
        stateList:[
          {
            value: 'STATE_END',
            text: '마감'
          },
          {
            value: 'STATE_RECEIPT',
            text: '접수중'
          },
          {
            value: 'STATE_READY',
            text: '접수대기'
          },
          {
            value: 'STATE_CANCEL',
            text: '취소'
          },
        ],
        pagination: {
          sortBy: 'createdAt',
          rowsPerPage: 20
        },
        waitingSearch: false,
      }
  ),
  watch: {
    options: {
      handler() {
        this.search();
      },
      deep: true,
    },
    'param.searchKeyword': {
      handler(nv) {
        this.options.page = 1;
        this.param.searchKeyword = nv;
        if (!this.waitingSearch) {
          setTimeout(() => {
            this.search();
            this.waitingSearch = false;
          }, 500); // 0.5 sec delay
        }
        this.waitingSearch = true;
      },
      deep: true
    },
    'param.searchDate': {
      handler() {
        this.search();
      },
      deep: true
    }
  },
  methods: {
    search() {
      const {  page, itemsPerPage, size } = this.options;

      let params = {...this.param, ...{
          page: page,
          size: size ? size : itemsPerPage
        }};

      // console.log(params)
      if (this.param.searchDate?.length??0 > 0) {
        params.startDate = this.param.searchDate[0];
        params.endDate = this.param.searchDate?.[1]??this.param.searchDate[0];
      } else {
        params.startDate = null;
        params.endDate = null;
      }
      if (this.param.searchDate?.length??0 > 0) {
        params.startDate = this.param.searchDate[0];
        params.endDate = this.param.searchDate?.[1]??this.param.searchDate[0];
      } else {
        params.startDate = null;
        params.endDate = null;
      }

      presentApi.list(params).then(data => {
        this.datasets = data.content;
        this.totalItems = data.totalElements;
        this.$store.commit('setParams', params);
      });
    },
    getSearchDate(searchDate = []) {
      this.param.searchDate = searchDate;
    },
    selectSearchDate(months) {
      this.activeItem = months;
      // 0 is total
      if (this.activeItem !== 0) {
        this.param.searchDate = [this.$moment().subtract(months, "months").format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
      } else
        this.param.searchDate = [];
    },
    updateForm(item) {
      this.$router.push({path:`/present/form/${item.presentId}`});
    },
    preview(item) {
      window.open(`${process.env.VUE_APP_HOME}/gift/${item.presentId}/preview`, 'preview', 'scrollbars=yes,width=417,height=700');
    },
    async deletePresent(item) {
      if (confirm(`${item.title} 를 삭제하시겠습니까?`)) {
        presentApi.delete(item.presentId).then(() => {
          this.search();
        });
      }
    },
  },
  created() {

    const storedParams = this.$store.getters?.params??{};
    if(storedParams.name !== this.$options.name)
      this.$store.commit('setParams', Object.assign(this.param, {name:this.$options.name}))
    else {
      this.options = storedParams
      this.param = storedParams
    }

  }

}
</script>


<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}

.fieldWrap {
  @include form-bx;

  .fieldBx {
    position: relative;
    width: 1600px;

    .searchBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 1.7%;
    }

    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
        }

        dd {
          display: flex;
          align-items: center;

          span {
            margin-left: 8px;
          }

          &:nth-child(2) {
            padding-left: 5px;
            padding-bottom: 3px;
          }

          .monthBx {
            display: flex;
            align-items: center;
            height: 35px;
            width: 280px;
            border-radius: 3px;
            border: 1px solid #1867c0;

            .month {
              &:first-child {
                padding-left: 10px;
              }
              width: 55px;
              height: 100%;
              padding: 0 8px;
              border: 0;
              background: #fff;
              font-size: 13px;
              font-weight: normal;
              color: #1867c0;

              &.active {
                background: #1867c0;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}

.tableWrap {
  .tableBtnBx {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .searchAll {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      /*font-size: 13px;*/
      .txtPoint {
        color: $point-color;
      }
    }
  }

  .tableBtn {
    ul {
      display: flex;
      flex-direction: row;
      align-items: center;

      .tableBtnList {
        //margin-right: 15px;
      }
    }
  }
}
</style>
